import { http } from 'connex-cds';

export default {
  listUsers: ({ entityRef }) => http.get({ apiName: 'cxp', path: `/${entityRef}/users` }),
  inviteUser: ({ entityRef, user }) => http.post({ apiName: 'cxp', path: `/${entityRef}/users/invite`, data: user }),
};
